/* global define */

define('views/TopSearchBarView',[
	'jquery',
	'underscore',
	'backbone',
	'bootstrap-multiselect',
	'views/DropdownView',
	'text!templates/views/TopSearchBar.html'
], function($, _, Backbone, bootstrapmultiselect, DropdownControl, template) {

	'use strict';

	var View = Backbone.View.extend({
		controls: {},
		dropdowns: [],
		events: {
			'click .toggleAdvancedButton': 'toggleAdvancedButton',
			'click .overlaysButton': 'toggleOverlays',
			'click .searchButton': 'search',
			'click .fullscreenButton': 'fullscreen'
		},
		initialize: function() {

			// Bind All
			_.bindAll(this);

			// TODO RMOVE THIS
			this.$overlays = this.$el.find('.overlays');

			this.$window = $(window);

		},
		reset: function() {

			for (var i = 0; i < this.dropdowns.length; i++) {
				this.dropdowns[i].reset();
			}

		},
		clear: function() {

			for (var i = 0; i < this.dropdowns.length; i++) {
				this.dropdowns[i].clear();
			}

		},
		render: function() {

			var topbar_controls = this.options.gmapsearch.topbar_controls,
				dropdown = null,
				topbarControl = null,
				options = null;

			this.$el.html(template);

			// Hide areas button if there are no package.
			if(!this.options.gmapsearch.map_packages || this.options.gmapsearch.map_packages.length === 0){
				this.$el.find('.overlaysButton').hide();
			}

			this.$overlaysBytton = this.$el.find('.overlaysButton');

			var $dropdowns = this.$el.find('.dropdowns');

			/* NO SUPPORTED
ctrlType: "price"
textWidth: 70*/

			// TODO setVal method
			//value: ""
			//
			
			if(!topbar_controls){
				return this;
			}

			for (var i = 0; i < topbar_controls.length; i++) {

				topbarControl = topbar_controls[i];
				options = topbarControl.values;

				if (topbarControl.ctrlType === 'price' || topbarControl.ctrlType === 'size' || topbarControl.ctrlType === 'year') {

					var other = {
						name: 'Other',
						value: 'other'
					};
					options.push(other);

				}

				dropdown = new DropdownControl({
					id: topbarControl.name,
					title: topbarControl.label,
					name: topbarControl.name,
					options: options,
					//align:topbarControl.align,
					align: 'left',
					value: topbarControl.value,
					data: topbarControl,
					width: topbarControl.textWidth
				});

				dropdown.on('change', this.onDropdownChange);
				this.dropdowns.push(dropdown);

				// Prime the form
				this.trigger('change', topbarControl.name, topbarControl.value);

				$dropdowns.append(dropdown.render().el);

			}

			return this;
		},
		onDropdownChange: function(event) {

			var name = event.options.name,
				dropdown = event.dropdown;

			// Sets the tile back to the default one
			if(dropdown.getValue() === ''){
				//dropdown.reset();
			}

			if (event.value !== 'other') {
				this.trigger('change', name, dropdown.getValue());
				return;
			}

			if (name === 'PRICE') {
				this.promptOtherPrice(dropdown);
			} else if (name === 'YEAR_BUILT') {
				this.promptOtherYear(dropdown);
			} else if (name === 'AREA_SQ_FEET') {
				this.promptOtherSize(dropdown);
			}

		},
		toggleAdvancedButton: function(){
			this.trigger('toggleAdvancedOptions');
		},
		toggleOverlays: function() {

			if (this.$overlaysBytton.hasClass('btn-primary')){
				this.disableOverlays();
				this.trigger('hideOverlays');
			}
			else{
				this.enableOverlays();
				this.trigger('showOverlays');
			}

		},
		showOverlays: function() {
			this.trigger('showOverlays');
		},
		enableOverlays: function() {
			this.$overlaysBytton.addClass('btn-primary');
		},
		hideOverlays: function() {
			this.trigger('hideOverlays');
		},
		disableOverlays: function() {
			this.$overlaysBytton.removeClass('btn-primary');
		},
		promptOtherPrice: function(dropdown) {

			if (!this.$priceModal) {

				var _this = this,
					template = $.trim(this.$el.find('#otherPriceModalTemplate').html()),
					html = _.template(template, {
						title: 'Price Range'
					}),
					$modal = $(html);

				$modal.find('.closeAdvanceButton').on('click', function() {
					$modal.modal('hide');
					dropdown.reset();
				});

				$modal.find('.okButton').on('click', function() {

					var fromString = $modal.find('input.from').val(),
						from = parseInt(fromString, 10),
						toString = $modal.find('input.to').val(),
						to = parseInt(toString, 10);

					if (fromString !== '' && isNaN(from)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum price is invalid');
					} else if (toString !== '' && isNaN(to)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Maximum price is invalid');
					} else if (fromString !== '' && toString !== '' && from > to) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum price must be smaller than the maximum price');
					} else {


						if (isNaN(from)) {
							from = '';
						} else if (isNaN(to)) {
							to = '';
						}

						var newOption = {},
							value = '',
							name = '',
							longName = '';

						if(from !== ''){
							value += from + '000';
							name = '$' + from + 'k';
							longName = '$' + from + '000';
						}
						else{
							name += '<';
							longName += '<';
						}

						value += '-';
						name += '-';
						longName += ' - ';

						if(to !== ''){
							value += to + '000';
							name += to + 'k';
							longName = '$' + to + '000';
						}
						else{
							name += '>';
							longName += '>';
						}

						newOption.name = name;
						newOption.longName = longName;
						newOption.value = value;
					dropdown.addOption(newOption, true);

						$modal.modal('hide');
						_this.trigger('change',  dropdown.getName(), dropdown.getValue());

					}
				});

				$modal.on('shown', function() {
					//$modal.center();
				});

				this.$priceModal = $modal;
			}

			this.$priceModal.modal('show');
		},
		promptOtherYear: function(dropdown) {

			if (!this.$yearModal) {

				var _this = this,
					template = $.trim(this.$el.find('#otherYearModalTemplate').html()),
					html = _.template(template, {
						title: 'Age Range'
					}),
					$modal = $(html);

				$modal.find('.closeAdvanceButton').on('click', function() {
					$modal.modal('hide');
					dropdown.reset();
				});

				$modal.find('.okButton').on('click', function() {

					var from = parseInt($modal.find('input.from').val(), 10),
						to = parseInt($modal.find('input.to').val(), 10);

					if (isNaN(from)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum year is invalid');
					} else if (isNaN(to)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Maximum year is invalid');
					} else if (from > to) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum year must be smaller than the maximum year');
					} else {

						var newOption = {};
						newOption.longName = from + ' years - ' + to;
						newOption.name = from + '-' + to;
						newOption.value = from + '-' + (to + 1);
						dropdown.addOption(newOption, true);
						$modal.modal('hide');
						_this.trigger('change',  dropdown.getName(), dropdown.getValue());

					}


				});

				this.$yearModal = $modal;
			}

			this.$yearModal.modal('show');

		},
		promptOtherSize: function(dropdown) {

			if (!this.$sizeModal) {

				var _this = this,
					template = $.trim(this.$el.find('#otherSizeModalTemplate').html()),
					html = _.template(template, {
						title: 'Living Area Range'
					}),
					$modal = $(html);

				$modal.find('.closeAdvanceButton').on('click', function() {
					$modal.modal('hide');
					dropdown.reset();
				});

				$modal.find('.okButton').on('click', function() {

					var from = parseInt($modal.find('input.from').val(), 10),
						to = parseInt($modal.find('input.to').val(), 10);

					if (isNaN(from)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum space is invalid');
					} else if (isNaN(to)) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Maximum space is invalid');
					} else if (from > to) {
						$modal.find('.control-group').addClass('error');
						$modal.find('.help-inline').text('Minimum space must be smaller than the maximum space');
					} else {

						var newOption = {};
						newOption.longName = from + ' sqft - ' + to + ' sqft';
						newOption.name = from + '-' + to + ' sqft';
						newOption.value = from + '-' + (to + 1);
						dropdown.addOption(newOption, true);
						$modal.modal('hide');
						_this.trigger('change',  dropdown.getName(), dropdown.getValue());

					}

				});

				this.$sizeModal = $modal;

			}

			this.$sizeModal.modal('show');

		},
		getControls: function() {
			return this.controls;
		},
		search: function(event) {
			this.trigger('search', event);
		},

		initIframePath: function(){

			this.iframePath = [];

			function recurseTree(parent, map, element){

				try{
                    if(element.contentDocument){
                        element = element.contentDocument;
                    }
                }
                catch(err) {
                    //return;
                }

				var $iframes = $(element).find('iframe');

				if(!parent.children){
					parent.children = [];
				}

				$iframes.each(function(index, element){

					if(!element.src || element.src.indexOf("gmform15/index") === -1){
						return true;
					}

					var child = {};
					child.id = $(element).attr('id');
					child.parent = parent;
					child.element = element;
					parent.children.push(child);

					if(child.id){
						map[child.id] = child;
					}

					recurseTree(child, map, element);
				});

			}

			var root = {},
				map = {},
				$topDocument = $(window.top.document);

			recurseTree(root, map, $topDocument);

			if(map.gmform){
				this.iframePath = map.gmform;
			}
			else{
				this.iframePath = root.children[0];
			}


		},

		fullscreenIframe: function(node){

			if(!node || !node.element){
				return;
			}

			var $element = $(node.element);

			if(!node.previousStyle){
				node.previousStyle = $element.attr('style');
			}

			$element.attr('style','background-color:white;position:fixed; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;');

			$(window.top.document).find('body').css('overflow', 'hidden');

			if(node.parent){
				this.fullscreenIframe(node.parent);
			}

		},

		exitFullscreenIframe: function(node){

			if(!node || !node.element){
				return;
			}

			var $element = $(node.element);

			if(node.previousStyle){
				$element.attr('style',node.previousStyle);
			}

			$(window.top.document).find('body').css('overflow', 'auto');

			if(node.parent){
				this.exitFullscreenIframe(node.parent);
			}

		},

		fullscreen: function(event){

			if(!this.iframePath){
				this.initIframePath();
			}

			var $i = this.$el.find(".fullscreenButton i")

			if($i.hasClass('icon-resize-full')){
				this.fullscreenIframe(this.iframePath);
				$i.addClass('icon-resize-small');
				$i.removeClass('icon-resize-full');
				this.trigger('fullscreen', true);
			}
			else{
				this.exitFullscreenIframe(this.iframePath);
				$i.addClass('icon-resize-full');
				$i.removeClass('icon-resize-small');
				this.trigger('fullscreen', false);
			}
			
		}

	});
	return View;
});
